import styleInject from '#style-inject';styleInject(".straumur__apple-pay-button__loading{display:flex;justify-content:center}\n")